/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Summermodestate2Inputs */



/**
* | output |
* | --- |
* | "Winter mode state" |
*
* @param {Br_History_Key_Summermodestate2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_summermodestate2 = /** @type {((inputs?: Br_History_Key_Summermodestate2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Summermodestate2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter mode state")
	return /** @type {LocalizedString} */ ("Etat du mode hiver")
});
export { br_history_key_summermodestate2 as "br_history_key_summerModeState" }